module.exports = __webpack_public_path__ + "img/badge-anniversaire.e3df844c.png";